import React, { useEffect, useState, useCallback } from "react";
import styles from "./FixedAssetsTable.module.css";
import Pagination from "./Pagination";
import { fixedAssetListing } from "../../../Bookclosure/Services/ApiHandler";

const FixedAssetTable = ({ FixedAssetID = "6923ff38b2634815b2602d1d" }) => {
  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [totalPages, setTotalPages] = useState(1);
  
  const formatHeading = (text) =>
    text
      .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .trim();
  
  const loadData = useCallback(async () => {
    try {
      const response = await fixedAssetListing(FixedAssetID, {
        page: currentPage,
        pageSize: rowsPerPage,
      });
      
      const res = response.data;
      
      setColumns(res.fixedAssetListingHeaders);
      setData(res.fixedAssetListing);
      setTotalPages(res.totalPages);
    } catch (error) {
      console.error("Error loading data:", error);
    }
  }, [FixedAssetID, currentPage, rowsPerPage]);
  
  useEffect(() => {
    loadData();
  }, [loadData]);
  
  return (
    <div className={styles.wrapper}>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              {columns.map((col) => (
                <th key={col}>
                  {formatHeading(col)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, i) => (
              <tr key={i}>
                {columns.map((col) => (
                  <td key={col}>
                    {row[col] ?? "-"}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      <div className={styles.paginationWrapper}>
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={(rows) => {
            setRowsPerPage(rows);
            setCurrentPage(1);
          }}
        />
      </div>
    </div>
  );
};

export default FixedAssetTable;